import {Component, Input, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {CardDto, CardService, CardState} from '../../../_services/configuration-services';
import {FormBuilder, UntypedFormControl, UntypedFormGroup, Validators} from '@angular/forms';
import { firstValueFrom } from 'rxjs';

@Component({
    selector: 'app-rfid-card-modal',
    templateUrl: './rfid-card-modal.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class RfidCardModalComponent implements OnInit {

    @Input() rfidCard: CardDto | null;
    @Input() cardNumberDisabled = false;
    @Input() uidDisabled = false;

    rfidForm: UntypedFormGroup;
    cardStates = Object.keys(CardState).filter(s => s !== CardState.Virtual);

    constructor(public activeModal: NgbActiveModal,
                private readonly rfidCardService: CardService,
                private readonly fb: FormBuilder) {
    }

    ngOnInit(): void {
        this.rfidForm = this.fb.group({
                cardNumber: [{value: null, disabled: this.cardNumberDisabled}, Validators.required],
                uid: [{value: null, disabled: this.uidDisabled}, Validators.required],
                cardState: [{ value: null }, Validators.required],
            },
            {updateOn: 'change'}
        );

        if(this.rfidCard){
            this.rfidForm.patchValue(this.rfidCard);
        }

        if (this.rfidCard?.customerId) {
            this.cardStates = this.cardStates.filter(c => c !== CardState.Unassigned)
        } else {
            this.cardStates = this.cardStates.filter(c => c !== CardState.Assigned)
        }

        this.cardState.setValue(this.rfidCard?.cardState);
    }

    async addOrUpdate(): Promise<void> {
        const rfiCard = new CardDto();
        rfiCard.cardNumber = this.rfidForm.controls['cardNumber'].value.trim();
        rfiCard.uid = this.rfidForm.controls['uid'].value.trim();
        rfiCard.customerId = this.rfidCard?.customerId;

        rfiCard.cardState = this.cardState.value;

        if (!this.rfidCard?.cardNumber) {
            await firstValueFrom(this.rfidCardService.createRfidCard(rfiCard));
            this.activeModal.close('success');
        } else {
            await firstValueFrom(this.rfidCardService.updateRfidCard(this.rfidCard.cardNumber, rfiCard));
            this.activeModal.close('success');
        }
    }

    get cardNumber(): UntypedFormControl {
        return this.rfidForm.get('cardNumber') as UntypedFormControl;
    }

    get uid(): UntypedFormControl {
        return this.rfidForm.get('uid') as UntypedFormControl;
    }

    get cardState(): UntypedFormControl {
        return this.rfidForm.get('cardState') as UntypedFormControl;
    }
}
